import { type MetaFunction } from '@remix-run/node'
import { Button } from '#app/components/ui/button.js'
import { Icon } from '#app/components/ui/icon.js'

export const meta: MetaFunction = () => [{ title: 'Kogia | About Us' }]

export default function About() {
	return (
		<>
			<div
				style={{
					backgroundImage:
						'url(https://images.squarespace-cdn.com/content/v1/5f27401564a09e77e7fe96c2/bd1619c7-6443-4c04-9086-b3dff9afc92b/Website+Mainpage.jpg)',
				}}
				className="flex h-[90vh] w-full flex-col items-center justify-center gap-4 bg-muted bg-cover bg-center text-white"
			>
				<h2 className="font-serif text-h2 leading-none">About Kogia</h2>
				<p>
					A non-profit media library and production studio dedicated to
					protecting marine life.
				</p>
				<Button
					className="border-2 border-white text-primary text-white"
					size={'lg'}
					variant={'ghost'}
				>
					<Icon size="lg" name="video">
						Watch Video
					</Icon>
				</Button>
			</div>
			<div className="flex gap-16 p-16">
				<div className="flex flex-1 basis-1/2 flex-col gap-4">
					<img
						alt="Library"
						src="https://images.squarespace-cdn.com/content/v1/5f27401564a09e77e7fe96c2/8cf892b4-b9b4-4865-aac2-795359bda85e/20191129-KARIM-ILIYA-9713.jpg?format=2500w"
					/>
					<h2 className="font-serif text-h3">Library</h2>
					<p className="flex-1">
						<strong>
							Kogia is a free library of ocean photography and video from around
							the world, free to use
						</strong>{' '}
						for small ocean conservation organizations, non-profits, activists,
						marine scientists and artists who are working to protect our oceans.
						Fill out our quick membership application form linked below for
						access to the library.
					</p>
					<Button className="mt-2" size="lg">
						<Icon name="envelope-closed">Apply Here</Icon>
					</Button>
				</div>
				<div className="flex flex-1 basis-1/2 flex-col gap-4">
					<img
						alt="Studio"
						src="https://images.squarespace-cdn.com/content/v1/5f27401564a09e77e7fe96c2/d7110c0f-2457-484d-8987-fbbc9b57fb52/20180927-KARIM-ILIYA-9363.jpg?format=2500w"
					/>
					<h2 className="font-serif text-h3">Studio</h2>
					<p className="flex-1">
						<strong>
							We produce our own documentaries and photo stories about the
							marine world and the people who work to protect it.
						</strong>{' '}
						Through storytelling we document the beauty of the oceans and
						support those on the frontline of conservation.
					</p>
					<Button className="mt-2" size="lg">
						<Icon name="video">Learn More</Icon>
					</Button>
				</div>
			</div>
		</>
	)
}
